import { selectTranslator } from 'core/redux/features/languages/trans';
import { selectActiveProduct } from 'core/redux/features/products/reducers/products';
import { selectDeviceType } from 'core/redux/reducers';
import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

interface IProps {
  className?: string;
  children: React.ReactNode;
  url?: string | null;
  linkType?: boolean;
  onClick?: () => void;
}

const BookButton = memo(function (props: IProps) {
  const { className, url, linkType, onClick } = props;

  const deviceType = useSelector(selectDeviceType);
  const product = useSelector(selectActiveProduct);
  const trans = useSelector(selectTranslator);

  const [route, setRoute] = useState<string | null>(null);

  useEffect(
    function () {
      let routeUrl: string;
      if (url) {
        routeUrl = url;
      } else {
        let slug = product?.product_type ?? '';
        if (slug === 'restaurant') {
          slug = trans('booking_restaurant_slug');
        }
        routeUrl = trans(`routes.book`, {
          step: 'step1',
          slug: product?.slug ?? '',
          productType: slug,
        });
      }

      setRoute(routeUrl);
    },
    [product?.product_type, product?.slug, trans, url],
  );

  const cls = className;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();

    if (product && product.status === 'in-stock') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: window.__defaultLocaleData__.currency,
          value: product.price_sale,
          items: [
            {
              item_name: product.name,
              item_id: product.id,
              price: product.price_sale,
              item_category: product.product_type,
              quantity: 1,
            },
          ],
        },
      });
    }

    if (deviceType !== 'mobile' && product?.status !== 'in-stock') {
      onClick();
    } else {
      //@ts-ignore
      window.location.href = route;
    }
  };
  return (
    <>
      {linkType && route ? (
        <Link onClick={handleClick} to={route} className={cls}>
          {props.children}
        </Link>
      ) : (
        <a onClick={handleClick} className={cls} href={route}>
          {props.children}
        </a>
      )}
    </>
  );
});

// const BookButton = connect((state: AppState) => ({
//   product: selectActiveProduct(state),
//   trans: selectTranslator(state),
//   deviceType: state.deviceType,
// }))(BookButtonComp);

export default BookButton;
